"use client";

import { ChevronLeft, Loader2, Send } from "lucide-react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Heading } from "@/components/ui/Heading";
import { toast } from "sonner";
import TextInput from "@/components/account/input/TextInput";
import { newsletterSubscribe } from "@/core/lib/api/main/landing";
import { emailSchema, EmailSchemaData } from "@/core/schemas/newsletterSchema";
import { useDictionary } from "@/core/hooks/use-dictionary";

export default function Newsletter() {
  const { dictionary } = useDictionary();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
  } = useForm<EmailSchemaData>({
    resolver: zodResolver(emailSchema),
  });

  const onSubmit = async (data: EmailSchemaData) => {
    try {
      const result = await newsletterSubscribe({ email: data.email });

      if (result?.status === "success") {
        toast.success(result.message);
        reset();
      } else if (result.status === "validation_error" && result.data) {
        toast.error(result.message);
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("خطا در ثبت");
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="justify-between gap-3 flex absolute top-0 bottom-0 m-auto h-fit flex-col">
      <div className="space-y-10 flex flex-col items-center">
        <Heading level={3} className="mb-1">
          {dictionary.ui?.newsletter.title}
        </Heading>
        <p className="text-primary-600 mb-3">
          {dictionary.ui?.newsletter.description}
        </p>
      </div>
      <div className="h-10 rounded-full relative w-full md:w-100 bg-secondary-200 px-4 space-y-2">
        <TextInput
          label=""
          placeholder={dictionary.ui?.newsletter.placeholder}
          errors={errors}
          register={register}
          name={"email"}
          variant="secondary"
          inputClassName="w-full border-0 placeholder-primary-0 text-primary-0"
        />

        <button
          type="submit"
          className="absolute top-1/9 p-2 rtl:left-1 bg-primary-0 ltr:right-1 rounded-full"
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <Loader2 className="w-4 animate-spin" />
          ) : (
            <ChevronLeft className="w-4 h-4 text-primary-900 rtl:rotate-360" />
          )}
        </button>
      </div>
    </form>
  );
}
